import axiosBase from 'axios'
import Constants from '../../constants'

const Axios = {
  setup: function() {
    const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
    const baseURL = Constants.API_BASE_URL_LIST[env_key] + '/'
    const a = axiosBase.create({
      baseURL: baseURL,
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'json'
    })

    return a
  }
}

export default Axios
